import { createFeature, createReducer, on, provideState } from '@ngrx/store';
import { makeEnvironmentProviders } from '@angular/core';
import { provideEffects } from '@ngrx/effects';
import { AutocompleteAction } from './autocomplete.action';
import { AutocompleteEffects } from './autocomplete.effects';

export const initialState: Readonly<Suggestions> = {
  suggestionsList: [],
  keyword: '',
};

export const autocompleteFeature = createFeature({
  name: 'Autocomplete',
  reducer: createReducer(
    initialState,
    on(AutocompleteAction.setKeyword, (state, { value }) => {
      return { ...state, keyword: value };
    }),
    on(AutocompleteAction.setList, (state, { value }) => {
      return { ...state, suggestionsList: value };
    }),
    on(AutocompleteAction.clearList, (state) => {
      return { ...state, suggestionsList: [] };
    })
  ),
});

export const { selectAutocompleteState, selectSuggestionsList } =
  autocompleteFeature;

export function provideAutocompleteFeature() {
  return makeEnvironmentProviders([
    provideState(autocompleteFeature),
    provideEffects(AutocompleteEffects),
  ]);
}
